module.exports = __webpack_public_path__ + "img/program_process.ae2d1766.png";